const config = {
    listeners: {
      basket: {
          added: 'basket.added',
          deleted: 'basket.deleted',
          update: 'basket.update'
      }
    },
    tokens: {
        suggestions: '8400756363f79eca7c0fe43dafa1c2eab74a2a72'
    }
};
export default config;